var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouthA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 6,
    viewBox: "0 0 43 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0399133 0.721449C0.193896 0.191065 0.748685 -0.114069 1.27907 0.0399133C8.97694 2.27478 15.0018 3.35 21.0607 3.33776C27.123 3.32551 33.2768 2.22459 41.2351 0.0360541C41.7676 -0.110388 42.318 0.202587 42.4645 0.735103C42.6109 1.26762 42.2979 1.81802 41.7654 1.96446C33.7237 4.17593 27.3775 5.325 21.0648 5.33776C14.7487 5.35052 8.52358 4.22574 0.721449 1.96061C0.191065 1.80662 -0.114069 1.25183 0.0399133 0.721449Z",
    fill: "#181111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouthA);
export default __webpack_public_path__ + "static/media/Mouth A.f1e103fa4b9065baaa0b0e16ca422386.svg";
export { ForwardRef as ReactComponent };